import { render, staticRenderFns } from "./SectionPage.vue?vue&type=template&id=9582ac86&scoped=true&"
import script from "./SectionPage.vue?vue&type=script&lang=js&"
export * from "./SectionPage.vue?vue&type=script&lang=js&"
import style0 from "./SectionPage.vue?vue&type=style&index=0&id=9582ac86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9582ac86",
  null
  
)

export default component.exports